import React from "react";
import CountUp from "./CountUp";

const STATS = [
  { end: 25, suffix: " Million", label: "Guest interactions", useSeparator: false },
  { end: 10000, suffix: "+", label: "Events & activations" },
  { end: 2012, suffix: "", label: "Company founded", useSeparator: false },
];

const CELEBRITIES_IMG =
  "https://customer-assets.emergentagent.com/job_guest-intelligence/artifacts/1ch6q1qc_celebrities-love.png";

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="relative z-10 border-y border-stori-border bg-stori-bg overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-6 lg:pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`trust-stat-${i}`}
              className="flex flex-col gap-3 md:border-l md:border-stori-border md:first:border-l-0 md:pl-8 md:first:pl-0"
            >
              <CountUp
                end={s.end}
                suffix={s.suffix}
                useSeparator={s.useSeparator !== false}
                duration={s.end > 1000000 ? 2400 : 1800}
                className="font-heading text-5xl md:text-6xl lg:text-7xl font-semibold text-white tracking-tight leading-none"
              />
              <div className="font-mono text-xs uppercase tracking-[0.2em] text-stori-muted">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bridge caption */}
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 mt-10 lg:mt-14">
        <div className="flex items-center gap-4">
          <span className="h-px flex-1 bg-stori-border" />
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-stori-cyan whitespace-nowrap">
            · The faces behind the numbers ·
          </span>
          <span className="h-px flex-1 bg-stori-border" />
        </div>
      </div>

      {/* Celebrities collage — full-bleed image under the stats */}
      <div className="relative mt-8 lg:mt-12">
        <div className="relative max-w-[1600px] mx-auto px-2 md:px-6">
          <img
            src={CELEBRITIES_IMG}
            alt="Celebrities and guests captured through Stori installations"
            loading="lazy"
            data-testid="celebrities-collage"
            className="w-full h-auto block"
          />
          <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-stori-bg to-transparent pointer-events-none" />
          <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-stori-bg to-transparent pointer-events-none" />
        </div>

        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-10 lg:pb-14 flex justify-center">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-stori-muted">
            — captured live across 27 countries —
          </span>
        </div>
      </div>
    </section>
  );
}
